// @flow
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';
import { LOAD_SIMILAR_ITEMS_V3_SUCCESS } from './actions';

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    loaded: {},
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_SIMILAR_ITEMS_V3_SUCCESS:
            const existing = cloneDeep(state.byId);
            action.payload.forEach(({ categories, itemId }) => {
                existing[itemId] = categories;
            });
            return {
                ...state,
                byId: existing,
                loaded: {
                    ...state.loaded,
                    [action.meta.itemId]: action.meta.actionTime,
                },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.similarItemsCategories;

const idSelector = (state, id) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

export const getSimilarItemCategories = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || []);
